import { styled, TableCell, TableRow, TableCellProps, TableRowProps } from "@mui/material";

export const StyledRow = styled(TableRow, {
    name: "StyledRow",
    slot: "Wrapper",
    shouldForwardProp: (prop) => prop !== 'sx'
})<TableRowProps>({
    innerHeight: 10
});

export const StyledCell = styled(TableCell, {
    name: "StyledCell",
    slot: "Wrapper",
    shouldForwardProp: (prop) => prop !== 'sx'
})<TableCellProps>({
    padding: '0.2rem'
});